// import React, { useEffect, useState, useRef, useCallback } from 'react'
// import Header from '../../layouts/Header'
// import {
//     ArrowLeft, Eye, FileEarmarkExcel, FileEarmarkSpreadsheet, Funnel, Printer, ThreeDotsVertical,
//     CloudDownload, ArrowClockwise, HourglassSplit, CheckCircle, ExclamationTriangle, BoxArrowDown,
//     Clock, XCircle, X,
// } from 'react-bootstrap-icons';
// import { Badge, Button, Col, Dropdown, Form, FormControl, InputGroup, Modal, Row, Spinner, Table } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import Select from 'react-select';
// import makeAnimated from "react-select/animated";
// import axiosInstance from '../../api/axios'; import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import OutletSelect from '../../components/OutletSelect';

// const REPORT_TYPE = 'SUBSCRIPTION_CONSUMPTION_REPORT';

// /* ─────────────────────────────────────────────────────────
//    DOWNLOAD MANAGER STYLES (scoped with "scr-" prefix so they
//    never collide with any other page's styles)
// ───────────────────────────────────────────────────────── */
// const DM_CSS = `
//   .scr-fab{
//     height:38px; border-radius:8px; padding:0 16px;
//     background:#fff; border:1.5px solid #e2e6ea;
//     display:inline-flex; align-items:center; justify-content:center;
//     cursor:pointer; transition:all .18s;
//     color:#41505F; font-size:13px; font-weight:600; gap:7px;
//     white-space:nowrap; box-shadow:0 1px 3px rgba(0,0,0,.08);
//   }
//   .scr-fab:hover{border-color:#2563eb;color:#2563eb;background:#eff6ff;}
//   .scr-fab.has-active{border-color:#2563eb;color:#2563eb;background:#eff6ff;}
//   .scr-badge{
//     background:#dc2626; color:#fff;
//     width:18px; height:18px; border-radius:50%;
//     margin-left:2px;
//     font-size:10px; font-weight:700;
//     display:inline-flex; align-items:center; justify-content:center;
//   }
//   .scr-pulse{animation:scr-pulse 1.5s ease-in-out infinite;}
//   @keyframes scr-pulse{0%,100%{opacity:1;}50%{opacity:.5;}}
//   .scr-spin{animation:scr-spin .9s linear infinite;display:inline-block;}
//   @keyframes scr-spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}

//   .scr-panel{
//     position:fixed; top:72px; right:24px; z-index:1049;
//     width:580px; max-height:700px;
//     background:#fff;
//     border-radius:14px;
//     border:1.5px solid #e2e6ea;
//     box-shadow:0 20px 60px rgba(0,0,0,.15),0 4px 16px rgba(0,0,0,.08);
//     display:flex; flex-direction:column;
//     overflow:hidden;
//     animation:scr-in .2s ease;
//   }
//   @keyframes scr-in{from{opacity:0;transform:translateY(-8px) scale(.97);}to{opacity:1;transform:translateY(0) scale(1);}}

//   .scr-header{
//     display:flex; align-items:flex-start; justify-content:space-between;
//     padding:20px 22px 18px;
//     background:linear-gradient(135deg,#0f172a 0%,#1e3a8a 60%,#1d4ed8 100%);
//     color:#fff; flex-shrink:0;
//   }
//   .scr-header-left{flex:1;}
//   .scr-header-title{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:700;letter-spacing:-.2px;}
//   .scr-header-sub{font-size:11.5px;opacity:.6;margin-top:3px;}
//   .scr-stats{display:flex;gap:10px;margin-top:14px;}
//   .scr-stat{background:rgba(255,255,255,.1);border-radius:8px;padding:9px 16px;text-align:center;border:1px solid rgba(255,255,255,.12);min-width:70px;}
//   .scr-stat-val{font-size:20px;font-weight:700;color:#fff;line-height:1;}
//   .scr-stat-lbl{font-size:10px;opacity:.65;margin-top:4px;text-transform:uppercase;letter-spacing:.6px;}
//   .scr-header-actions{display:flex;align-items:center;gap:6px;flex-shrink:0;padding-top:2px;}
//   .scr-icon-btn{width:30px;height:30px;border-radius:7px;border:none;background:rgba(255,255,255,.12);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .15s;}
//   .scr-icon-btn:hover{background:rgba(255,255,255,.25);}

//   .scr-body{overflow-y:auto;flex:1;padding:14px 16px;display:flex;flex-direction:column;gap:10px;background:#f8fafc;}
//   .scr-body::-webkit-scrollbar{width:5px;}
//   .scr-body::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:4px;}

//   .scr-job{display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;border:1px solid #e2e6ea;background:#fff;transition:box-shadow .15s,border-color .15s;}
//   .scr-job:hover{box-shadow:0 4px 12px rgba(0,0,0,.09);border-color:#cbd5e1;}
//   .scr-job-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:17px;}
//   .scr-job-icon.pending{background:#fef3c7;color:#d97706;}
//   .scr-job-icon.processing{background:#eff6ff;color:#2563eb;}
//   .scr-job-icon.completed{background:#ecfdf5;color:#059669;}
//   .scr-job-icon.failed{background:#fef2f2;color:#dc2626;}
//   .scr-job-icon.no_data{background:#f3f4f6;color:#6b7280;}
//   .scr-job-info{flex:1;min-width:0;}
//   .scr-job-name{font-size:13px;font-weight:600;color:#1a202c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
//   .scr-job-meta{font-size:11.5px;color:#64748b;margin-top:3px;display:flex;align-items:center;gap:6px;flex-wrap:wrap;}

//   .scr-pb-wrap{height:4px;background:#e2e8f0;border-radius:3px;margin-top:7px;overflow:hidden;}
//   .scr-pb{height:100%;border-radius:3px;transition:width .5s ease;}
//   .scr-pb.pending{background:#fcd34d;width:8%;}
//   .scr-pb.processing{background:#2563eb;width:60%;animation:scr-pb-shimmer 1.5s ease-in-out infinite;}
//   .scr-pb.completed{background:#059669;width:100%;}
//   .scr-pb.failed{background:#dc2626;width:100%;}
//   .scr-pb.no_data{background:#9ca3af;width:100%;}
//   @keyframes scr-pb-shimmer{0%,100%{opacity:1;}50%{opacity:.55;}}

//   .scr-status-pill{font-size:10.5px;font-weight:700;padding:3px 10px;border-radius:20px;white-space:nowrap;flex-shrink:0;}
//   .scr-status-pill.pending{background:#fef3c7;color:#d97706;}
//   .scr-status-pill.processing{background:#eff6ff;color:#2563eb;}
//   .scr-status-pill.completed{background:#ecfdf5;color:#059669;}
//   .scr-status-pill.failed{background:#fef2f2;color:#dc2626;}
//   .scr-status-pill.no_data{background:#f3f4f6;color:#6b7280;}

//   .scr-dl-btn{height:32px;padding:0 14px;border-radius:8px;border:1.5px solid #a7f3d0;background:#ecfdf5;color:#059669;font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;transition:all .15s;white-space:nowrap;flex-shrink:0;}
//   .scr-dl-btn:hover{background:#059669;color:#fff;border-color:#059669;}

//   .scr-del-btn{
//     width:30px; height:30px; border-radius:8px;
//     border:1.5px solid #fecaca; background:#fef2f2;
//     color:#dc2626; cursor:pointer;
//     display:inline-flex; align-items:center; justify-content:center;
//     transition:all .15s; flex-shrink:0;
//   }
//   .scr-del-btn:hover:not(:disabled){background:#dc2626;color:#fff;border-color:#dc2626;}
//   .scr-del-btn:disabled{opacity:.5;cursor:not-allowed;}

//   .scr-regen-btn{
//     width:30px; height:30px; border-radius:8px;
//     border:1.5px solid #bfdbfe; background:#eff6ff;
//     color:#2563eb; cursor:pointer;
//     display:inline-flex; align-items:center; justify-content:center;
//     transition:all .15s; flex-shrink:0;
//   }
//   .scr-regen-btn:hover:not(:disabled){background:#2563eb;color:#fff;border-color:#2563eb;}
//   .scr-regen-btn:disabled{opacity:.5;cursor:not-allowed;}

//   .scr-footer{padding:12px 18px;border-top:1px solid #e2e6ea;flex-shrink:0;display:flex;align-items:center;justify-content:space-between;background:#fff;}
//   .scr-footer-info{font-size:12px;color:#41505F;display:flex;align-items:center;gap:5px;}
//   .scr-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;color:#41505F;text-align:center;gap:10px;}

//   .scr-multi-notice{margin-top:12px;padding:12px 16px;border-radius:8px;background:#fffbeb;border:1.5px solid #fde68a;display:flex;align-items:flex-start;gap:10px;}
//   .scr-multi-notice-text{font-size:12.5px;color:#92400e;line-height:1.5;}
//   .scr-multi-notice-text strong{color:#78350f;}

//   @media(max-width:768px){
//     .scr-panel{width:calc(100vw - 32px);left:16px;right:16px;top:72px;}
//   }
// `;

// const SubscriptionConsumptionReport = () => {

//     const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
//     const [skin, setSkin] = useState(currentSkin);
//     const animatedComponents = makeAnimated();
//     const customStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             width: "100%",
//             borderRadius: "6px",
//             minWidth: "200px",
//             borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
//             "&:hover": {
//                 borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             },
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             color: "#6c757d",
//         }),
//     };

//     const accessToken = localStorage.getItem("authToken");
//     const navigate = useNavigate();
//     const [error, setError] = useState('');
//     const [outlets, setOutlets] = useState([]);

//     /* ── Outlet selection is now multi-select. Single outlet keeps the
//        existing inline Generate/Download flow; 2+ outlets always schedules
//        a background Excel export (no date range on this page). ── */
//     const [selectedOutlet, setSelectedOutlet] = useState([]);
//     const isMultiOutletSelected = selectedOutlet && selectedOutlet.length > 1;

//     const [selectedSubscription, setSelectedSubscription] = useState('');
//     const [subscriptionList, setSubscriptionList] = useState([]);
//     const [btnLoading, setBtnLoading] = useState(false);
//     const [printBtnLoading, setPrintBtnLoading] = useState(false);
//     const [searchText, setSearchText] = useState('');
//     const [clicked, setClicked] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [filteredData, setFilteredData] = useState([]);
//     const [openViewModal, setOpenViewModal] = useState(false);
//     const [singleData, setSingleData] = useState({});

//     /* Whether the currently "generated" report is a queued background
//        job (multi-outlet) rather than the inline single-outlet table */
//     const [scheduledMode, setScheduledMode] = useState(false);

//     /* ── Download Manager state ── */
//     const [dmOpen, setDmOpen] = useState(false);
//     const [downloadJobs, setDownloadJobs] = useState([]);
//     const [pollingActive, setPollingActive] = useState(false);
//     const [jobsLoading, setJobsLoading] = useState(false);
//     const [deletingJobId, setDeletingJobId] = useState(null);
//     const [regeneratingJobId, setRegeneratingJobId] = useState(null);
//     const pollingRef = useRef(null);
//     const dmPanelRef = useRef(null);

//     /* Date filter only used to browse job history inside the Download
//        Manager panel — the main report screen has no date range. */
//     const [dmStartDate, setDmStartDate] = useState(() => {
//         const d = new Date();
//         return new Date(d.getFullYear(), d.getMonth(), 1);
//     });
//     const [dmEndDate, setDmEndDate] = useState(() => {
//         const d = new Date();
//         return new Date(d.getFullYear(), d.getMonth(), d.getDate());
//     });

//     const fmtDate = (d) => {
//         if (!d) return undefined;
//         return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
//     };

//     const getOutlets = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("outlet", { headers });

//             if (response?.data?.status === true) {
//                 const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE");
//                 setOutlets(filteredOutlets);
//             }
//         } catch (error) {
//             handleApiError(error);
//         }
//     };

//     // Fetch subscriptions
//     const getSubscriptions = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("subscription", { headers });
//             setSubscriptionList(response?.data?.data?.subscriptions);
//             console.log("Subscription List :", response?.data?.data?.subscriptions);

//         } catch (error) {
//             toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
//                 position: "top-right",
//                 autoClose: 3000,
//                 theme: "colored",
//             });
//         }
//     };

//     /* Single-outlet inline fetch — unchanged, just now takes the single
//        outlet object out of the selectedOutlet array. */
//     const getConsumptionReport = async (outlet) => {
//         console.log("Selected Outlet :", outlet);

//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`
//             };
//             let url = `subscription-purchase/outletsubscription`;
//             if (outlet) {
//                 url += `?outletId=${outlet?.value}`
//             }
//             const response = await axiosInstance.get(url, { headers });
//             setSubscriptionList(response?.data?.data?.list);
//             setFilteredData(response?.data?.data?.list);
//             console.log("Subscription List sdsdsdsd:", response?.data?.data);

//         } catch (error) {
//             toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
//                 position: "top-right",
//                 autoClose: 3000,
//                 theme: "light",
//             });
//         } finally {
//             setLoading(false);
//         }
//     }

//     const handleApiError = (error) => {
//         let errorMessage = 'An error occurred';
//         if (error.response?.status === 406) {
//             errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
//         } else if (error.response?.status === 412) {
//             errorMessage = error.response?.data?.data?.message;
//         } else if (error.response?.status === 500) {
//             errorMessage = error.response?.data?.error;
//         }

//         toast.error(errorMessage, {
//             position: "top-right",
//             autoClose: 3000,
//             theme: "light",
//         });
//     };

//     const handleEndDateChange = (e) => {

//     };

//     const handlePrintReport = () => {
//         console.log("You Are In Print Function");
//     };

//     /* Single-outlet direct Excel download — unchanged behaviour */
//     const handleDownloadReportSingle = async () => {
//         setPrintBtnLoading(true);
//         try {
//             const outlet = selectedOutlet?.[0];
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//                 "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//             };

//             let url = `subscription-purchase/outletsubscription?isDownload=true`;
//             if (outlet) {
//                 url += `&outletId=${outlet.value}`;
//             }

//             const response = await axiosInstance.get(url, {
//                 headers,
//                 responseType: 'blob' // This is correct in the config object
//             });

//             // Create a blob from the response data
//             const blob = new Blob([response.data], {
//                 type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
//             });

//             // Create a link element
//             const link = document.createElement('a');
//             link.href = window.URL.createObjectURL(blob);

//             // Set the filename for the download
//             const fileName = `Subscritpion Consumption Report For - ${outlet?.label || 'Outlet'}.xlsx`;
//             link.download = fileName;

//             // Append the link to the body and trigger the download
//             document.body.appendChild(link);
//             link.click();

//             // Clean up
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(link.href);

//             toast.success("Report downloaded successfully!", {
//                 position: "top-right",
//                 autoClose: 3000,
//                 theme: "light",
//             });
//         } catch (error) {
//             handleApiError(error);
//         } finally {
//             setPrintBtnLoading(false);
//         }
//     };

//     /* ═══════════════════════════════════════════════════════
//        MULTI-OUTLET — schedule a background Excel job
//        POST subscription-purchase/outletsubscription/new
//             ?page=1&limit=10&isDownload=true
//             body: { outletIds: [...] }
//     ═══════════════════════════════════════════════════════ */
//     const triggerScheduledDownload = async () => {
//         setPrintBtnLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const outletIds = selectedOutlet.map((o) => o.value);

//             await axiosInstance({
//                 method: "POST",
//                 url: "subscription-purchase/outletsubscription/new",
//                 params: { page: 1, limit: 10, isDownload: true },
//                 data: { outletIds },
//                 headers: { ...headers, "Content-Type": "application/json" },
//             });

//             toast.success("Download job queued! Track progress in Download Manager.", {
//                 position: "top-right", autoClose: 2500, theme: "light",
//             });
//             setDmOpen(true);
//             startPolling();
//         } catch (error) {
//             handleApiError(error);
//         } finally {
//             setPrintBtnLoading(false);
//         }
//     };

//     /* Entry point wired to the download/schedule button */
//     const handleDownloadReport = async () => {
//         if (!selectedOutlet || selectedOutlet.length === 0) {
//             toast.info("Please select at least one outlet.", {
//                 position: "top-right", autoClose: 2500, theme: "light",
//             });
//             return;
//         }
//         if (isMultiOutletSelected) {
//             await triggerScheduledDownload();
//         } else {
//             await handleDownloadReportSingle();
//         }
//     };

//     /* Entry point wired to the "Generate Report" button.
//        Only meaningful for a single selected outlet — the inline GET
//        endpoint doesn't support multiple outletIds at once. */
//     const handleSubmitReport = async () => {
//         if (!selectedOutlet || selectedOutlet.length === 0) {
//             toast.info("Please select an outlet to view the report.", {
//                 position: "top-right", autoClose: 2500, theme: "light",
//             });
//             return;
//         }
//         if (isMultiOutletSelected) {
//             toast.info("Multiple outlets selected — use Schedule Download to get a combined Excel export instead.", {
//                 position: "top-right", autoClose: 3000, theme: "light",
//             });
//             return;
//         }
//         setClicked(true);
//         setScheduledMode(false);
//         setLoading(true);
//         await getConsumptionReport(selectedOutlet[0]);
//     };

//     const handleViewDetails = (data) => {
//         setOpenViewModal(true);
//         console.log("Single Data :", data);

//         setSingleData(data);
//     }

//     /* ═══════════════════════════════════════════════════════
//        DOWNLOAD MANAGER — poll GET
//        /report/get-report-status/SUBSCRIPTION_CONSUMPTION_REPORT
//     ═══════════════════════════════════════════════════════ */
//     const fetchDownloadStatus = useCallback(
//         async (silent = false, overrideStart, overrideEnd) => {
//             try {
//                 if (!silent) setJobsLoading(true);
//                 const headers = { Authorization: `Bearer ${accessToken}` };
//                 const sDate = overrideStart !== undefined ? overrideStart : dmStartDate;
//                 const eDate = overrideEnd !== undefined ? overrideEnd : dmEndDate;

//                 const res = await axiosInstance.get(
//                     `report/get-report-status/${REPORT_TYPE}`,
//                     { headers, params: { startDate: fmtDate(sDate), endDate: fmtDate(eDate) } }
//                 );
//                 const jobs = res?.data?.data?.reportRequests || res?.data?.reportRequests || [];
//                 const jobArr = Array.isArray(jobs) ? jobs : [];
//                 const sorted = [...jobArr].sort((a, b) => {
//                     const termA = a.status === "COMPLETED" || a.status === "FAILED";
//                     const termB = b.status === "COMPLETED" || b.status === "FAILED";
//                     if (termA !== termB) return termA ? 1 : -1;
//                     return new Date(b.createdAt) - new Date(a.createdAt);
//                 });
//                 setDownloadJobs(sorted);
//                 const allDone = jobArr.every((j) => j.status === "COMPLETED" || j.status === "FAILED");
//                 if (allDone && jobArr.length > 0) stopPolling();
//             } catch (e) {
//                 console.error("Poll error:", e);
//             } finally {
//                 if (!silent) setJobsLoading(false);
//             }
//         },
//         [accessToken, dmStartDate, dmEndDate]
//     );

//     const startPolling = useCallback(() => {
//         setPollingActive(true);
//         fetchDownloadStatus(true);
//         if (pollingRef.current) clearInterval(pollingRef.current);
//         pollingRef.current = setInterval(() => fetchDownloadStatus(true), 5000);
//     }, [fetchDownloadStatus]);

//     const stopPolling = useCallback(() => {
//         setPollingActive(false);
//         if (pollingRef.current) {
//             clearInterval(pollingRef.current);
//             pollingRef.current = null;
//         }
//     }, []);

//     const handleDmDateChange = (type, date) => {
//         if (type === "start") {
//             setDmStartDate(date);
//             if (date && dmEndDate) {
//                 const diffDays = (dmEndDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
//                 if (diffDays > 30) {
//                     const clampedEnd = new Date(date);
//                     clampedEnd.setDate(clampedEnd.getDate() + 30);
//                     setDmEndDate(clampedEnd);
//                     fetchDownloadStatus(false, date, clampedEnd);
//                     return;
//                 }
//             }
//             fetchDownloadStatus(false, date, dmEndDate);
//         } else {
//             setDmEndDate(date);
//             fetchDownloadStatus(false, dmStartDate, date);
//         }
//     };

//     const handleDeleteReportRequest = async (jobId) => {
//         try {
//             setDeletingJobId(jobId);
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             await axiosInstance.delete("report/delete-report-request", {
//                 headers,
//                 data: { requestId: jobId },
//             });
//             toast.success("Request cancelled successfully.", {
//                 position: "top-right", autoClose: 2000, theme: "light",
//             });
//             fetchDownloadStatus(true);
//         } catch (error) {
//             toast.error("Failed to cancel request.", {
//                 position: "top-right", autoClose: 3000, theme: "light",
//             });
//         } finally {
//             setDeletingJobId(null);
//         }
//     };

//     const handleRegenerateReport = async (jobId) => {
//         try {
//             setRegeneratingJobId(jobId);
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             await axiosInstance.delete("report/delete-report-storage-path", {
//                 headers,
//                 data: { requestId: jobId },
//             });
//             toast.success("Report regeneration triggered! Please wait…", {
//                 position: "top-right", autoClose: 2500, theme: "light",
//             });
//             startPolling();
//             fetchDownloadStatus(true);
//         } catch (error) {
//             toast.error("Failed to trigger regeneration.", {
//                 position: "top-right", autoClose: 3000, theme: "light",
//             });
//         } finally {
//             setRegeneratingJobId(null);
//         }
//     };

//     const fmtJobTimestamp = (dateInput) => {
//         if (!dateInput) return '';
//         try {
//             const d = new Date(dateInput);
//             return `${d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })} ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
//         } catch (e) {
//             return '';
//         }
//     };

//     const downloadFile = (job) => {
//         const url = job.storagePath;
//         if (!url) {
//             toast.error("File URL not available.");
//             return;
//         }
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = `Subscription_Consumption_Report_${job.queryParams?.startDate || ''}_${job.queryParams?.endDate || ''}.xlsx`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const getJobCls = (s) => {
//         const v = s?.toLowerCase();
//         if (v === "completed") return "completed";
//         if (v === "failed") return "failed";
//         if (v === "no_data") return "no_data";
//         if (v === "processing" || v === "in-progress") return "processing";
//         return "pending";
//     };
//     const getJobIcon = (s) => {
//         const c = getJobCls(s);
//         if (c === "completed") return <CheckCircle size={16} />;
//         if (c === "failed") return <ExclamationTriangle size={16} />;
//         if (c === "no_data") return <ExclamationTriangle size={16} />;
//         if (c === "processing")
//             return (
//                 <span className="scr-spin">
//                     <ArrowClockwise size={16} />
//                 </span>
//             );
//         return <HourglassSplit size={16} />;
//     };
//     const getJobLabel = (s) =>
//     ({
//         completed: "Completed",
//         failed: "Failed",
//         no_data: "No data found for selected filters",
//         processing: "Processing...",
//         pending: "Queued",
//     }[getJobCls(s)] || "Queued");

//     const pendingCount = downloadJobs.filter(
//         (j) => getJobCls(j.status) === "pending" || getJobCls(j.status) === "processing"
//     ).length;
//     const completedCount = downloadJobs.filter((j) => getJobCls(j.status) === "completed").length;
//     const failedCount = downloadJobs.filter((j) => getJobCls(j.status) === "failed").length;

//     useEffect(() => {
//         getOutlets();
//         getSubscriptions();
//         // Load any in-flight/completed download jobs on mount
//         fetchDownloadStatus(true);
//     }, []);

//     // Close Download Manager panel on outside click, stop polling on unmount
//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (dmPanelRef.current && !dmPanelRef.current.contains(e.target)) {
//                 const fab = document.getElementById("scr-fab");
//                 if (fab && !fab.contains(e.target)) setDmOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     useEffect(() => () => stopPolling(), []);

//     return (
//         <React.Fragment>
//             <style>{DM_CSS}</style>
//             <Header onSkin={setSkin} />
//             <div
//                 className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"
//                     }`}
//             >
//                 <div className="card shadow-sm border-0">
//                     <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
//                         <div>
//                             <h4 className="mb-0 fw-bold d-inline-block">
//                                 <i className="bi bi-clipboard-data me-2"></i>SUBSCRIPTION CONSUMPTION REPORT
//                             </h4>
//                         </div>
//                         <div className="d-flex align-items-center">
//                             <button
//                                 id="scr-fab"
//                                 className={`scr-fab me-3${pendingCount > 0 ? " has-active" : ""}`}
//                                 onClick={() => setDmOpen((o) => !o)}
//                                 title="Download Manager"
//                             >
//                                 <CloudDownload size={15} />
//                                 Downloads
//                                 {pendingCount > 0 && (
//                                     <span className="scr-badge scr-pulse">{pendingCount}</span>
//                                 )}
//                                 {pendingCount === 0 && completedCount > 0 && (
//                                     <span className="scr-badge" style={{ background: "#059669" }}>
//                                         {completedCount}
//                                     </span>
//                                 )}
//                             </button>
//                             <Button
//                                 variant="outline-secondary"
//                                 size="sm"
//                                 onClick={() => navigate('/reports/all-reports')}
//                                 className="d-flex align-items-center fw-semibold"
//                                 style={{ height: '38px' }}
//                             >
//                                 <ArrowLeft className="me-1" /> Back to Reports
//                             </Button>
//                         </div>
//                     </div>
//                     <hr className='mt-0 mb-0' />

//                     <div className="card-body">
//                         {/* Filters Section */}
//                         <div className="p-3 bg-light rounded-3">
//                             {/* <Form onSubmit={handleSubmitReport}> */}
//                             <Row className="g-3">
//                                 <Col md={4}>
//                                     <Form.Group controlId="outletSelect">
//                                         <OutletSelect
//                                             isMulti
//                                             value={selectedOutlet}
//                                             onChange={(opts) => setSelectedOutlet(Array.isArray(opts) ? opts : [])}
//                                             placeholder="Select one or more outlets…"
//                                             required={true}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                                 {selectedOutlet?.length <= 1 && (
//                                     <Col md={2} className="d-flex align-items-end">
//                                         <Button
//                                             variant="primary"
//                                             type="submit"
//                                             className="w-100"
//                                             disabled={!selectedOutlet || selectedOutlet.length !== 1}
//                                             onClick={handleSubmitReport}
//                                             title={isMultiOutletSelected ? "Generate Report only supports a single outlet" : ""}
//                                         >
//                                             {btnLoading ? (
//                                                 <Spinner size="sm" animation="border" />
//                                             ) : (
//                                                 "Generate Report"
//                                             )}
//                                         </Button>
//                                     </Col>
//                                 )}

//                                 <Col md={2} lg={2} className="d-flex w-25 align-items-end">
//                                     <Button
//                                         variant="outline-success"
//                                         className="w-100 fw-semibold"
//                                         disabled={!selectedOutlet || selectedOutlet.length === 0}
//                                         onClick={handleDownloadReport}
//                                     >
//                                         <FileEarmarkSpreadsheet className='me-2' />
//                                         {printBtnLoading ? (
//                                             <Spinner size="sm" animation="border" />
//                                         ) : isMultiOutletSelected ? (
//                                             "Schedule Download"
//                                         ) : (
//                                             "Download Report"
//                                         )}
//                                     </Button>
//                                 </Col>
//                                 {isMultiOutletSelected && (
//                                     <Col xs={12}>
//                                         <div className="scr-multi-notice">
//                                             <ExclamationTriangle size={16} style={{ marginTop: 2, flexShrink: 0, color: '#d97706' }} />
//                                             <div className="scr-multi-notice-text">
//                                                 <strong>{selectedOutlet.length} outlets selected</strong> — inline preview isn't
//                                                 available for multiple outlets. Click <strong>Schedule Download</strong> to queue
//                                                 a combined Excel export and track it via the <strong>Downloads</strong> button above.
//                                             </div>
//                                         </div>
//                                     </Col>
//                                 )}
//                             </Row>
//                             {/* </Form> */}
//                         </div>

//                     </div>

//                     {!clicked ? (
//                         <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
//                             <div className="text-center">
//                                 <i className="bi bi-clipboard-data fs-1 text-muted"></i>
//                                 <h5 className="text-muted mt-3">
//                                     Please select outlet to view report
//                                 </h5>
//                             </div>
//                         </div>
//                     ) : scheduledMode ? (
//                         <div className="d-flex flex-column justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
//                             <CloudDownload size={28} className="text-primary mb-2" />
//                             <h6 className="text-muted mb-1">Report queued for download</h6>
//                             <p className="text-muted mb-0" style={{ fontSize: 13 }}>
//                                 Check the <strong>Downloads</strong> panel above for your Excel file.
//                             </p>
//                         </div>
//                     ) : (
//                         <>

//                             {/* Items Table */}
//                             <div className="table-responsive border rounded-3 m-3">
//                                 <Table striped bordered hover className="mb-0">
//                                     <thead className="bg-light">
//                                         <tr>
//                                             <th>#</th>
//                                             <th>Date</th>
//                                             <th>Outlet Name</th>
//                                             <th>Subscription Plan</th>
//                                             <th className="text-center">Order Count</th>
//                                             <th>Subscription Amount Used</th>
//                                             <th className="text-center">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {loading ? (
//                                             <tr>
//                                                 <td colSpan="12" className="text-center py-4">
//                                                     <Spinner animation="border" variant="primary" />
//                                                     <p className="mt-2 mb-0">Loading item data...</p>
//                                                 </td>
//                                             </tr>
//                                         ) : filteredData?.length > 0 ? (
//                                             <>
//                                                 {filteredData?.map((product, index) => (
//                                                     <tr key={index}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td>{new Date(product?.subscriptionDetails?.createdAt).toLocaleString('en-IN', {
//                                                             day: '2-digit',
//                                                             month: 'short',
//                                                             year: 'numeric',
//                                                             hour: '2-digit',
//                                                             minute: '2-digit',
//                                                             hour12: true
//                                                         })}
//                                                         </td>

//                                                         <td>{product?.outletDetails?.name}</td>
//                                                         <td>
//                                                             <div className="text-primary">{product?.subscriptionDetails?.title}</div>
//                                                         </td>
//                                                         <td className="text-center">{product?.totalOrders}</td>
//                                                         <td className="text-end">₹ {product?.totalSubscriptionConsumedAmount?.toFixed(2)}</td>
//                                                         <td>
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
//                                                                     <ThreeDotsVertical size={15} />
//                                                                 </Dropdown.Toggle>
//                                                                 <Dropdown.Menu>
//                                                                     <Dropdown.Item onClick={() => handleViewDetails(product)}>
//                                                                         <Eye size={14} className="me-2" /> View
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </td>
//                                                     </tr>
//                                                 ))}

//                                             </>
//                                         ) : (
//                                             <tr>
//                                                 <td colSpan="7" className="text-center py-4">
//                                                     <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
//                                                     <p className="mt-2 mb-0 text-muted">
//                                                         No items found for the selected criteria
//                                                     </p>
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </Table>
//                             </div>

//                         </>
//                     )
//                     }

//                     {/* View Details Modal  */}
//                     {openViewModal && (
//                         <Modal
//                             show={openViewModal}
//                             onHide={() => setOpenViewModal(false)}
//                             size="xl"
//                             centered
//                             className="outlet-details-modal"
//                         >
//                             <Modal.Header closeButton className="border-bottom-0 pb-0">
//                                 <Modal.Title className="fw-bold">More Details</Modal.Title>
//                             </Modal.Header>

//                             <Modal.Body className="p-0">
//                                 {singleData && (
//                                     <div className="container-fluid">
//                                         <div className="row g-0">
//                                             {/* Left Column - Outlet Details */}
//                                             <div className="col-md-5 p-4 border-end" style={{ backgroundColor: '#f8f9fa' }}>
//                                                 <div className="sticky-top" style={{ top: '1rem' }}>

//                                                     {/* Outlet Information Card */}
//                                                     <div className="mb-4">
//                                                         <h5 className="fw-bold mb-3">Outlet Information</h5>
//                                                         <div className="card border-0 shadow-sm">
//                                                             <div className="card-body">
//                                                                 <div className="d-flex justify-content-between align-items-center mb-3">
//                                                                     <h6 className="mb-0">Status</h6>
//                                                                     <Badge
//                                                                         bg={singleData?.outletDetails?.status === 'ACTIVE' ? 'success' : 'danger'}
//                                                                         pill
//                                                                     >
//                                                                         {singleData?.outletDetails?.status}
//                                                                     </Badge>
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <h6 className="text-muted small mb-2">Outlet</h6>
//                                                                     <p className="mb-0">{singleData?.outletDetails?.name}</p>
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <h6 className="text-muted small mb-2">Opening Time</h6>
//                                                                     <p className="mb-0">{singleData?.outletDetails?.openingTime}</p>
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <h6 className="text-muted small mb-2">Closing Time</h6>
//                                                                     <p className="mb-0">{singleData?.outletDetails?.closingTime}</p>
//                                                                 </div>

//                                                                 {singleData?.outletDetails?.outletImage && (
//                                                                     <div className="mt-3">
//                                                                         <h6 className="text-muted small mb-2">Outlet Image</h6>
//                                                                         <img
//                                                                             src={`${singleData.outletDetails.outletImage}`}
//                                                                             className="img-fluid rounded border"
//                                                                             alt="Outlet"
//                                                                         />
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     {/* Subscription Details Card */}
//                                                     <div className="mb-4">
//                                                         <h5 className="fw-bold mb-3">Subscription Details</h5>
//                                                         <div className="card border-0 shadow-sm">
//                                                             <div className="card-body">
//                                                                 <div className="mb-3">
//                                                                     <h6 className="text-muted small mb-2">Subscription Plan</h6>
//                                                                     <p className="mb-0">{singleData?.subscriptionDetails?.title}</p>
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <h6 className="text-muted small mb-2">Days Excluded</h6>
//                                                                     <p className="mb-0">
//                                                                         {singleData?.subscriptionDetails?.excludedDays?.join(', ') || 'N/A'}
//                                                                     </p>
//                                                                 </div>

//                                                                 <div className="mb-3">
//                                                                     <h6 className="text-muted small mb-2">Price</h6>
//                                                                     <p className="mb-0">
//                                                                         ₹ {singleData?.subscriptionDetails?.price}
//                                                                     </p>
//                                                                 </div>

//                                                                 {singleData?.subscriptionDetails?.otherImage && (
//                                                                     <div className="mt-3">
//                                                                         <h6 className="text-muted small mb-2">Subscription Proof</h6>
//                                                                         <img
//                                                                             src={`${singleData?.subscriptionDetails?.otherImage}`}
//                                                                             className="img-fluid rounded border"
//                                                                             alt="Subscription Proof"
//                                                                         />
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     {/* Order Statistics Card */}
//                                                     <div className="card border-0 shadow-sm">
//                                                         <div className="card-body">
//                                                             <h5 className="fw-bold mb-3">Order Statistics</h5>

//                                                             <div className="d-flex justify-content-between mb-2">
//                                                                 <span className="text-muted">Total Orders:</span>
//                                                                 <span className="fw-bold">{singleData?.totalOrders}</span>
//                                                             </div>

//                                                             <div className="d-flex justify-content-between">
//                                                                 <span className="text-muted">Total Amount:</span>
//                                                                 <span className="fw-bold">₹ {singleData?.totalSubscriptionConsumedAmount?.toFixed(2)}</span>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Right Column - User Orders */}
//                                             <div className="col-md-7 p-4">
//                                                 <div className="d-flex justify-content-between align-items-center mb-4">
//                                                     <h5 className="fw-bold mb-0">User Orders</h5>
//                                                     <Badge bg="secondary" pill>
//                                                         {singleData?.usersWithOrders?.length || 0} users
//                                                     </Badge>
//                                                 </div>

//                                                 {singleData?.usersWithOrders?.length > 0 ? (
//                                                     <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
//                                                         {singleData.usersWithOrders.map((user, index) => (
//                                                             <div key={user?.userId} className="card border-0 shadow-sm mb-3">
//                                                                 <div className="card-body">
//                                                                     <div className="d-flex justify-content-between align-items-start mb-3">
//                                                                         <div>
//                                                                             <h6 className="fw-bold mb-1">{user?.userName}</h6>
//                                                                             <p className="text-muted small mb-1">{user?.userEmail}</p>
//                                                                             <p className="text-muted small mb-0">{user?.userMobile}</p>
//                                                                             <span className="text-muted small">Puchased on : {user?.purchase?.startDate}</span>
//                                                                             <br />
//                                                                             <span className="text-muted small">Expires or Expired on : {user?.purchase?.expiryDate}</span>
//                                                                         </div>
//                                                                         <div className="text-end">
//                                                                             <div className="fw-bold">
//                                                                                 ₹{user?.totalUserConsumedAmount?.toFixed(2)}
//                                                                             </div>
//                                                                             <Badge bg="light" text="dark" className="text-capitalize">
//                                                                                 {user?.orders?.length || 0} orders
//                                                                             </Badge>
//                                                                         </div>
//                                                                     </div>

//                                                                     {user?.orders?.length > 0 && (
//                                                                         <div className="border-top pt-3">
//                                                                             <h6 className="text-muted small mb-2">ORDERS</h6>
//                                                                             {user.orders.map((order, orderIndex) => (
//                                                                                 <div key={order._id} className="mb-3 pb-2 border-bottom">
//                                                                                     <div className="d-flex justify-content-between mb-1">
//                                                                                         <span className="fw-medium">Order #A{order.order_no}</span>
//                                                                                         <span className="fw-bold">₹{order.grandTotal?.toFixed(2)}</span>
//                                                                                     </div>
//                                                                                     <div className="d-flex justify-content-between text-muted small">
//                                                                                         <span>
//                                                                                             {new Date(order.createdAt).toLocaleString('en-US', {
//                                                                                                 year: 'numeric',
//                                                                                                 month: 'short',
//                                                                                                 day: 'numeric',
//                                                                                                 hour: '2-digit',
//                                                                                                 minute: '2-digit',
//                                                                                                 hour12: true
//                                                                                             })}
//                                                                                         </span>
//                                                                                         <span>
//                                                                                             {order.orderItem ? '1 item' : 'No items'}
//                                                                                         </span>
//                                                                                     </div>
//                                                                                 </div>
//                                                                             ))}
//                                                                         </div>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 ) : (
//                                                     <div className="text-center py-5">
//                                                         <div className="bg-light rounded-circle d-inline-flex p-4 mb-3">
//                                                             <Funnel size={28} className="text-muted" />
//                                                         </div>
//                                                         <h5 className="mb-2">No orders found</h5>
//                                                         <p className="text-muted">
//                                                             This outlet doesn't have any orders yet.
//                                                         </p>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </Modal.Body>

//                             <Modal.Footer className="border-top-0">
//                                 <Button variant="outline-secondary" onClick={() => setOpenViewModal(false)}>
//                                     Close
//                                 </Button>
//                             </Modal.Footer>
//                         </Modal>
//                     )}

//                     {/* ══════════════════════════════════════════
//                         FLOATING DOWNLOAD MANAGER PANEL
//                     ══════════════════════════════════════════ */}
//                     {dmOpen && (
//                         <div className="scr-panel" ref={dmPanelRef}>
//                             <div className="scr-header">
//                                 <div className="scr-header-left">
//                                     <div className="scr-header-title">
//                                         <CloudDownload size={17} /> Download Manager
//                                     </div>
//                                     <div className="scr-header-sub">
//                                         Subscription Consumption Report — scheduled exports
//                                     </div>

//                                     {/* Date filter (browse job history only) */}
//                                     <div style={{ display: "flex", gap: 10, marginTop: 12, alignItems: "center", flexWrap: "wrap" }}>
//                                         <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
//                                             <span style={{ fontSize: 9.5, fontWeight: 600, color: "rgba(255,255,255,.55)", textTransform: "uppercase", letterSpacing: ".6px" }}>
//                                                 From
//                                             </span>
//                                             <DatePicker
//                                                 selected={dmStartDate}
//                                                 onChange={(date) => handleDmDateChange("start", date)}
//                                                 dateFormat="dd-MM-yyyy"
//                                                 maxDate={new Date()}
//                                                 customInput={
//                                                     <input
//                                                         style={{
//                                                             height: 30, padding: "0 10px", borderRadius: 6,
//                                                             border: "1px solid rgba(255,255,255,.2)",
//                                                             background: "rgba(255,255,255,.1)", color: "#fff",
//                                                             fontSize: 12, fontWeight: 500, cursor: "pointer",
//                                                             outline: "none", width: 112,
//                                                         }}
//                                                     />
//                                                 }
//                                             />
//                                         </div>
//                                         <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
//                                             <span style={{ fontSize: 9.5, fontWeight: 600, color: "rgba(255,255,255,.55)", textTransform: "uppercase", letterSpacing: ".6px" }}>
//                                                 To
//                                             </span>
//                                             <DatePicker
//                                                 selected={dmEndDate}
//                                                 onChange={(date) => handleDmDateChange("end", date)}
//                                                 dateFormat="dd-MM-yyyy"
//                                                 minDate={dmStartDate}
//                                                 maxDate={(() => {
//                                                     if (!dmStartDate) return new Date();
//                                                     const max = new Date(dmStartDate);
//                                                     max.setDate(max.getDate() + 30);
//                                                     const today = new Date();
//                                                     return max > today ? today : max;
//                                                 })()}
//                                                 customInput={
//                                                     <input
//                                                         style={{
//                                                             height: 30, padding: "0 10px", borderRadius: 6,
//                                                             border: "1px solid rgba(255,255,255,.2)",
//                                                             background: "rgba(255,255,255,.1)", color: "#fff",
//                                                             fontSize: 12, fontWeight: 500, cursor: "pointer",
//                                                             outline: "none", width: 112,
//                                                         }}
//                                                     />
//                                                 }
//                                             />
//                                         </div>
//                                         <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
//                                             <span style={{ fontSize: 9.5, color: "transparent" }}>–</span>
//                                             <button
//                                                 style={{
//                                                     height: 30, padding: "0 12px", borderRadius: 6,
//                                                     border: "1px solid rgba(255,255,255,.25)",
//                                                     background: "rgba(255,255,255,.15)", color: "#fff",
//                                                     fontSize: 11.5, fontWeight: 600, cursor: "pointer",
//                                                     display: "inline-flex", alignItems: "center", gap: 5,
//                                                 }}
//                                                 onClick={() => fetchDownloadStatus(false)}
//                                                 disabled={jobsLoading}
//                                             >
//                                                 Apply
//                                             </button>
//                                         </div>
//                                         <span style={{ fontSize: 10, color: "rgba(255,255,255,.45)", alignSelf: "flex-end", marginBottom: 3 }}>
//                                             Max 30-day range
//                                         </span>
//                                     </div>

//                                     <div className="scr-stats">
//                                         <div className="scr-stat">
//                                             <div className="scr-stat-val">{downloadJobs.length}</div>
//                                             <div className="scr-stat-lbl">Total</div>
//                                         </div>
//                                         <div className="scr-stat">
//                                             <div className="scr-stat-val">{pendingCount}</div>
//                                             <div className="scr-stat-lbl">In Progress</div>
//                                         </div>
//                                         <div className="scr-stat">
//                                             <div className="scr-stat-val">{completedCount}</div>
//                                             <div className="scr-stat-lbl">Ready</div>
//                                         </div>
//                                         <div className="scr-stat">
//                                             <div className="scr-stat-val">{failedCount}</div>
//                                             <div className="scr-stat-lbl">Failed</div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="scr-header-actions">
//                                     {pollingActive && (
//                                         <span style={{ fontSize: 11, color: "rgba(255,255,255,.65)", display: "flex", alignItems: "center", gap: 4, marginRight: 4 }}>
//                                             <span className="scr-spin"><ArrowClockwise size={11} /></span> Live
//                                         </span>
//                                     )}
//                                     <button
//                                         className="scr-icon-btn"
//                                         onClick={() => {
//                                             setJobsLoading(true);
//                                             fetchDownloadStatus().finally(() => setJobsLoading(false));
//                                         }}
//                                         title="Refresh"
//                                         disabled={jobsLoading}
//                                     >
//                                         {jobsLoading ? (
//                                             <Spinner size="sm" animation="border" style={{ width: 12, height: 12 }} />
//                                         ) : (
//                                             <ArrowClockwise size={13} />
//                                         )}
//                                     </button>
//                                     <button className="scr-icon-btn" onClick={() => setDmOpen(false)} title="Close">
//                                         <X size={14} />
//                                     </button>
//                                 </div>
//                             </div>

//                             <div className="scr-body">
//                                 {downloadJobs.length === 0 ? (
//                                     <div className="scr-empty">
//                                         <CloudDownload size={40} style={{ opacity: 0.2 }} />
//                                         <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>
//                                             No download jobs yet
//                                         </div>
//                                         <div style={{ fontSize: 12.5, color: "#9ca3af", maxWidth: 280 }}>
//                                             Select multiple outlets above and click <strong>Schedule Download</strong> to queue a job.
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     downloadJobs.map((job, idx) => {
//                                         const cls = getJobCls(job.status);
//                                         const qp = job.queryParams || {};
//                                         const outlets = job.requestBody?.outletIds || [];
//                                         return (
//                                             <div key={job._id || idx} className="scr-job">
//                                                 <div className={`scr-job-icon ${cls}`}>
//                                                     {getJobIcon(job.status)}
//                                                 </div>
//                                                 <div className="scr-job-info">
//                                                     <div className="scr-job-name">
//                                                         Subscription Consumption Report
//                                                     </div>
//                                                     <div className="scr-job-meta">
//                                                         <span style={{ display: "flex", alignItems: "center", gap: 3 }}>
//                                                             <Clock size={10} /> {fmtJobTimestamp(job.createdAt)}
//                                                         </span>
//                                                         <span>·</span>
//                                                         <span>{outlets.length} outlet{outlets.length !== 1 ? "s" : ""}</span>
//                                                         {job.errorMessage && (
//                                                             <span style={{ color: "#dc2626" }}>· {job.errorMessage}</span>
//                                                         )}
//                                                     </div>
//                                                     <div className="scr-pb-wrap">
//                                                         <div className={`scr-pb ${cls}`} />
//                                                     </div>
//                                                 </div>
//                                                 <span className={`scr-status-pill ${cls}`}>{getJobLabel(job.status)}</span>
//                                                 {cls === "completed" && job.storagePath && (
//                                                     <button className="scr-dl-btn" onClick={() => downloadFile(job)}>
//                                                         <BoxArrowDown size={12} /> Download
//                                                     </button>
//                                                 )}

//                                                 {cls === "completed" && (
//                                                     <button
//                                                         className="scr-regen-btn"
//                                                         title="Regenerate this report"
//                                                         disabled={regeneratingJobId === job._id}
//                                                         onClick={() => handleRegenerateReport(job._id)}
//                                                     >
//                                                         {regeneratingJobId === job._id ? (
//                                                             <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
//                                                         ) : (
//                                                             <ArrowClockwise size={14} />
//                                                         )}
//                                                     </button>
//                                                 )}

//                                                 <button
//                                                     className="scr-del-btn"
//                                                     title="Cancel this request"
//                                                     disabled={deletingJobId === job._id}
//                                                     onClick={() => handleDeleteReportRequest(job._id)}
//                                                 >
//                                                     {deletingJobId === job._id ? (
//                                                         <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
//                                                     ) : (
//                                                         <XCircle size={14} />
//                                                     )}
//                                                 </button>
//                                             </div>
//                                         );
//                                     })
//                                 )}
//                             </div>

//                             <div className="scr-footer">
//                                 <span className="scr-footer-info">
//                                     {pollingActive ? (
//                                         <>
//                                             <span className="scr-spin" style={{ display: "inline-flex" }}>
//                                                 <ArrowClockwise size={12} />
//                                             </span>
//                                             Auto-refreshing every 5s
//                                         </>
//                                     ) : (
//                                         ""
//                                     )}
//                                 </span>
//                                 <button
//                                     style={{
//                                         height: 30, padding: "0 14px", borderRadius: 6,
//                                         border: "1.5px solid #e2e6ea", background: "#fff",
//                                         fontSize: 12, fontWeight: 500, color: "#41505F", cursor: "pointer",
//                                         display: "inline-flex", alignItems: "center", gap: 5,
//                                         opacity: pollingActive ? 0.5 : 1,
//                                     }}
//                                     onClick={startPolling}
//                                     disabled={pollingActive}
//                                 >
//                                     <ArrowClockwise size={11} /> Refresh
//                                 </button>
//                             </div>
//                         </div>
//                     )}

//                 </div>
//             </div>
//         </React.Fragment>
//     )
// }

// export default SubscriptionConsumptionReport




import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { ArrowLeft, Eye, FileEarmarkExcel, FileEarmarkSpreadsheet, Funnel, Printer, ThreeDotsVertical } from 'react-bootstrap-icons';
import { Badge, Button, Col, Dropdown, Form, FormControl, InputGroup, Modal, Row, Spinner, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import OutletSelect from '../../components/OutletSelect';

const SubscriptionConsumptionReport = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const animatedComponents = makeAnimated();
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    const accessToken = localStorage.getItem("authToken");
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState('');
    const [outlets, setOutlets] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [selectedSubscription, setSelectedSubscription] = useState('');
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [btnLoading, setBtnLoading] = useState(false);
    const [printBtnLoading, setPrintBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [clicked, setClicked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [singleData, setSingleData] = useState({});
    

    const getOutlets = async () => {
        try {
          const headers = { Authorization: `Bearer ${accessToken}` };
          const response = await axiosInstance.get("outlet", { headers });
    
          if (response?.data?.status === true) {
            const filteredOutlets = response?.data?.data?.outlets.filter((act) => act?.status === "ACTIVE");
            setOutlets(filteredOutlets);
          }
        } catch (error) {
          handleApiError(error);
        }
    };

    // Fetch subscriptions
    const getSubscriptions = async() => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("subscription", { headers });
            setSubscriptionList(response?.data?.data?.subscriptions);
            console.log("Subscription List :", response?.data?.data?.subscriptions);
            
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const getConsumptionReport = async(outlet) => {
        console.log("Selected Outlet :", outlet);
        
        try {
            const headers = { 
                Authorization: `Bearer ${accessToken}` 
            };
            let url = `subscription-purchase/outletsubscription`;
            if (outlet) {
                url += `?outletId=${outlet?.value}`
            }
            const response = await axiosInstance.get(url, { headers });
            setSubscriptionList(response?.data?.data?.list);
            setFilteredData(response?.data?.data?.list);
            console.log("Subscription List sdsdsdsd:", response?.data?.data);
            
        } catch (error) {
            toast.error(error.response?.data?.error || "Failed to fetch subscriptions", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setLoading(false);
        }
    }

    const handleApiError = (error) => {
        let errorMessage = 'An error occurred';
        if (error.response?.status === 406) {
            errorMessage = error.response?.data?.error?.message || error.response?.data?.error;
        } else if (error.response?.status === 412) {
            errorMessage = error.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
            errorMessage = error.response?.data?.error;
        }
    
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    const handleEndDateChange = (e) => {

    };

    const handlePrintReport = () => {
        console.log("You Are In Print Function");
        
    };

    const handleDownloadReport = async () => {
        setPrintBtnLoading(true);
        try {
            const headers = { 
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            };
            
            let url = `subscription-purchase/outletsubscription?isDownload=true`;
            if (selectedOutlet) {
                url += `&outletId=${selectedOutlet}`;
            }
            
            const response = await axiosInstance.get(url, { 
                headers,
                responseType: 'blob' // This is correct in the config object
            });

            // Create a blob from the response data
            const blob = new Blob([response.data], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Create a link element
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            
            // Set the filename for the download
            const fileName = `Subscritpion Consumption Report For - ${selectedOutletName}.xlsx`;
            link.download = fileName;
            
            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();
            
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);

            toast.success("Report downloaded successfully!", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } catch (error) {
            handleApiError(error);
        } finally {
            setPrintBtnLoading(false);
        }
    };

    const handleSubmitReport = async() => {
        setClicked(true);
        setLoading(true);
        await getConsumptionReport(selectedOutlet);
    };

    const handleViewDetails = (data) => {
        setOpenViewModal(true);
        console.log("Single Data :", data);
        
        setSingleData(data);
    }

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        
        setStartDate(start);
        setEndDate(end);
        getOutlets();
        getSubscriptions();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div
                className={`main main-app p-3 p-lg-4 ${
                skin === "dark" ? "bg-dark text-light" : "bg-light"
                }`}
            >
                <div className="card shadow-sm border-0">
                    <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-0 fw-bold d-inline-block">
                                <i className="bi bi-clipboard-data me-2"></i>SUBSCRIPTION CONSUMPTION REPORT
                            </h4>
                        </div>
                        <div>
                            <Button 
                                variant="outline-secondary" 
                                size="sm" 
                                onClick={() => navigate('/reports/all-reports')}
                                className="me-3 d-flex align-items-center fw-semibold"
                                style={{ height: '38px' }}
                            >
                                <ArrowLeft className="me-1" /> Back to Reports
                            </Button>
                        </div>
                    </div>
                    <hr className='mt-0 mb-0' />
               
                    <div className="card-body">
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3">
                            {/* <Form onSubmit={handleSubmitReport}> */}
                                <Row className="g-3">
                                    <Col md={3}>
                                        <Form.Group controlId="outletSelect">
                                            <OutletSelect
                                                value={selectedOutlet}
                                                onChange={(option) => {
                                                    console.log("Selected Outlet :", option);
                                                    setSelectedOutlet(option);
                                                    setSelectedOutletName(option ? option.label : '');
                                                }}
                                                required={true}
                                            />
                                            {/* <Form.Select
                                                value={selectedOutlet}
                                                onChange={(e) => {
                                                        setSelectedOutletName(e.target.selectedOptions[0].label)
                                                        setSelectedOutlet(e.target.value)
                                                    }
                                                }
                                                className="border-secondary"
                                            >
                                                <option value="">Select Outlet</option>
                                                {outlets?.map((outlet) => (
                                                <option key={outlet?._id} value={outlet?._id} label={`${outlet?.name}, ${outlet?.city}`}>
                                                    {outlet?.name}
                                                </option>
                                                ))}
                                            </Form.Select> */}
                                        </Form.Group>
                                    </Col>
                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={!selectedOutlet}
                                            onClick={handleSubmitReport}
                                        >
                                            {btnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate Report"
                                            )}
                                        </Button>
                                    </Col>
                                    <Col md={2} lg={2} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-success"
                                            className="w-100 fw-semibold"
                                            disabled={!selectedOutlet}
                                            onClick={handleDownloadReport}
                                        >
                                            <FileEarmarkSpreadsheet className='me-2' />
                                            {printBtnLoading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Download Report"
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            {/* </Form> */}
                        </div>
                
                    </div>

                    {!clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                    Please select outlet to view report
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <>
            
                                {/* Items Table */}
                                <div className="table-responsive border rounded-3 m-3">
                                    <Table striped bordered hover className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Outlet Name</th>
                                                <th>Subscription Plan</th>
                                                <th className="text-center">Order Count</th>
                                                <th>Subscription Amount Used</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center py-4">
                                                    <Spinner animation="border" variant="primary" />
                                                    <p className="mt-2 mb-0">Loading item data...</p>
                                                </td>
                                            </tr>
                                            ) : filteredData?.length > 0 ? (
                                            <>
                                                {filteredData?.map((product, index) => (
                                                    <tr key={index}>
                                                        <td className="text-muted">{index + 1}</td>
                                                        <td>{new Date(product?.subscriptionDetails?.createdAt).toLocaleString('en-IN', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                            })}
                                                        </td>

                                                        <td>{product?.outletDetails?.name}</td>
                                                        <td>
                                                            <div className="text-primary">{product?.subscriptionDetails?.title}</div>
                                                        </td>
                                                        <td className="text-center">{product?.totalOrders}</td>
                                                        <td className="text-end">₹ {product?.totalSubscriptionConsumedAmount?.toFixed(2)}</td>
                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
                                                                    <ThreeDotsVertical size={15} />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item onClick={() => handleViewDetails(product)}>
                                                                        <Eye size={14} className="me-2" /> View
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))}
                                                
                                            </>
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">
                                                        <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                                        <p className="mt-2 mb-0 text-muted">
                                                            No items found for the selected criteria
                                                        </p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
            
                            </>
                        )
                    }

                    {/* View Details Modal  */}
                    {openViewModal && (
                        <Modal 
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            size="xl"
                            centered
                            className="outlet-details-modal"
                        >
                            <Modal.Header closeButton className="border-bottom-0 pb-0">
                                <Modal.Title className="fw-bold">More Details</Modal.Title>
                            </Modal.Header>
                            
                            <Modal.Body className="p-0">
                            {singleData && (
                                <div className="container-fluid">
                                <div className="row g-0">
                                    {/* Left Column - Outlet Details */}
                                    <div className="col-md-5 p-4 border-end" style={{ backgroundColor: '#f8f9fa' }}>
                                    <div className="sticky-top" style={{ top: '1rem' }}>
                                        
                                        {/* Outlet Information Card */}
                                        <div className="mb-4">
                                        <h5 className="fw-bold mb-3">Outlet Information</h5>
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h6 className="mb-0">Status</h6>
                                                <Badge 
                                                bg={singleData?.outletDetails?.status === 'ACTIVE' ? 'success' : 'danger'} 
                                                pill
                                                >
                                                {singleData?.outletDetails?.status}
                                                </Badge>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Outlet</h6>
                                                <p className="mb-0">{singleData?.outletDetails?.name}</p>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Opening Time</h6>
                                                <p className="mb-0">{singleData?.outletDetails?.openingTime}</p>
                                            </div>

                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Closing Time</h6>
                                                <p className="mb-0">{singleData?.outletDetails?.closingTime}</p>
                                            </div>
                                            
                                            {singleData?.outletDetails?.outletImage && (
                                                <div className="mt-3">
                                                <h6 className="text-muted small mb-2">Outlet Image</h6>
                                                <img
                                                    src={`${singleData.outletDetails.outletImage}`}
                                                    className="img-fluid rounded border"
                                                    alt="Outlet"
                                                />
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        
                                        {/* Subscription Details Card */}
                                        <div className="mb-4">
                                        <h5 className="fw-bold mb-3">Subscription Details</h5>
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Subscription Plan</h6>
                                                <p className="mb-0">{singleData?.subscriptionDetails?.title}</p>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Days Excluded</h6>
                                                <p className="mb-0">
                                                {singleData?.subscriptionDetails?.excludedDays?.join(', ') || 'N/A'}
                                                </p>
                                            </div>
                                            
                                            <div className="mb-3">
                                                <h6 className="text-muted small mb-2">Price</h6>
                                                <p className="mb-0">
                                                ₹ {singleData?.subscriptionDetails?.price}
                                                </p>
                                            </div>
                                            
                                            {singleData?.subscriptionDetails?.otherImage && (
                                                <div className="mt-3">
                                                <h6 className="text-muted small mb-2">Subscription Proof</h6>
                                                <img
                                                    src={`${singleData?.subscriptionDetails?.otherImage}`}
                                                    className="img-fluid rounded border"
                                                    alt="Subscription Proof"
                                                />
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                        
                                        {/* Order Statistics Card */}
                                        <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <h5 className="fw-bold mb-3">Order Statistics</h5>
                                            
                                            <div className="d-flex justify-content-between mb-2">
                                            <span className="text-muted">Total Orders:</span>
                                            <span className="fw-bold">{singleData?.totalOrders}</span>
                                            </div>
                                            
                                            <div className="d-flex justify-content-between">
                                            <span className="text-muted">Total Amount:</span>
                                            <span className="fw-bold">₹ {singleData?.totalSubscriptionConsumedAmount?.toFixed(2)}</span>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    
                                    {/* Right Column - User Orders */}
                                    <div className="col-md-7 p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h5 className="fw-bold mb-0">User Orders</h5>
                                        <Badge bg="secondary" pill>
                                        {singleData?.usersWithOrders?.length || 0} users
                                        </Badge>
                                    </div>
                                    
                                    {singleData?.usersWithOrders?.length > 0 ? (
                                        <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                                            {singleData.usersWithOrders.map((user, index) => (
                                                <div key={user?.userId} className="card border-0 shadow-sm mb-3">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                                        <div>
                                                            <h6 className="fw-bold mb-1">{user?.userName}</h6>
                                                            <p className="text-muted small mb-1">{user?.userEmail}</p>
                                                            <p className="text-muted small mb-0">{user?.userMobile}</p>
                                                            <span className="text-muted small">Puchased on : {user?.purchase?.startDate}</span>
                                                                <br />
                                                            <span className="text-muted small">Expires or Expired on : {user?.purchase?.expiryDate}</span>
                                                        </div>
                                                        <div className="text-end">
                                                            <div className="fw-bold">
                                                                ₹{user?.totalUserConsumedAmount?.toFixed(2)}
                                                            </div>
                                                            <Badge bg="light" text="dark" className="text-capitalize">
                                                                {user?.orders?.length || 0} orders
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                    
                                                    {user?.orders?.length > 0 && (
                                                        <div className="border-top pt-3">
                                                            <h6 className="text-muted small mb-2">ORDERS</h6>
                                                            {user.orders.map((order, orderIndex) => (
                                                                <div key={order._id} className="mb-3 pb-2 border-bottom">
                                                                    <div className="d-flex justify-content-between mb-1">
                                                                    <span className="fw-medium">Order #A{order.order_no}</span>
                                                                    <span className="fw-bold">₹{order.grandTotal?.toFixed(2)}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between text-muted small">
                                                                        <span>
                                                                            {new Date(order.createdAt).toLocaleString('en-US', {
                                                                                year: 'numeric',
                                                                                month: 'short',
                                                                                day: 'numeric',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit',
                                                                                hour12: true
                                                                            })}
                                                                        </span>
                                                                        <span>
                                                                            {order.orderItem ? '1 item' : 'No items'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <div className="bg-light rounded-circle d-inline-flex p-4 mb-3">
                                                <Funnel size={28} className="text-muted" />
                                            </div>
                                            <h5 className="mb-2">No orders found</h5>
                                            <p className="text-muted">
                                                This outlet doesn't have any orders yet.
                                            </p>
                                        </div>
                                    )}
                                    </div>
                                </div>
                                </div>
                            )}
                            </Modal.Body>
                            
                            <Modal.Footer className="border-top-0">
                                <Button variant="outline-secondary" onClick={() => setOpenViewModal(false)}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                </div>
            </div>
        </React.Fragment>
    )
}

export default SubscriptionConsumptionReport